import { ref, Ref } from "vue";

interface State {
  customerName: Ref<string>;
}

const state: State = {
  customerName: ref(""),
};

export function useCustomerName(): State {
  return state;
}
